<template>
  <div class="leftnav">
    <div class="leftnav-top" @click="goHomePage" style="cursor: pointer">
      <div
        style="opacity: 1; padding-left: 35px"
        alt="百运网国际快递"
        title="百运网-跨境物流智能服务平台"
      >
        <img src="../../../../static/img/logo01.png" alt="" width="78" />
      </div>
      <div style="margin-top: 10px" v-if="pingPongLogo">
        <img
          src="../../../../static/img/pingpongLogo.png"
          alt=""
          style="width: 130px; margin: auto"
        />
      </div>
    </div>
    <div class="leftnav-bot">
      <div class="sidebar-scroll">
        <nav>
          <ul class="juzhong">
            <!-- v-if="
                item.IsShow ||
                item.ParentMenuName == '我的百运' ||
                item.ParentMenuName == '我的报表'
              " -->
            <li
              class="nav02 arrShow"
              ref="navtwo"
              v-for="(item, index) in parentList.filter(
                (item) =>
                  item.IsShow ||
                  item.MenuCode == 'MenuIndex' ||
                  item.ParentMenuName == '我的报表'
              )"
              :key="index"
            >
              <!-- <div class="navOne" :class="{ active: (index == firstLevelIndex),activeChild: (index == firstLevelIndex) }" @click="clickone(item, index)" :id="item.ID === 1 ? 'queryPrice' : ''"> -->
              <div
                class="navOne"
                :class="{
                  active: isChildActive && index == firstLevelIndex,
                  hightext: ishightText && item.ishightText,
                  activeMyInvite:
                    isChildActive &&
                    index == firstLevelIndex &&
                    item.ParentMenuName == '邀请有礼',
                }"
                @click="clickone(item, index)"
                :id="item.ID === 1 ? 'queryPrice' : ''"
              >
                <i
                  :class="[item.ico, { hightext: ishightText && item.ishightText }]"
                  class="fa iconColor"
                ></i>
                <span class="showspan">{{ item.ParentMenuName }}</span>
                <!-- <i :class="['icon-submenu','fa','lnr-chevron-left','arrTranForm']" v-if="item.ChilMenus.length > 0"></i> -->
                <div
                  v-if="item.ChilMenus.length > 0"
                  :class="['drowDown', item.show ? 'drowDownTrans' : 'closeDrow']"
                ></div>

                <img
                  v-if="item.MenuCode == 'MenuIndex'"
                  class="bq-img"
                  src="../../../../static/newStatic/img/newYear/标签查价下单@2x.png"
                  width="56px"
                  height="18px"
                  alt="查价下单"
                />
              </div>
              <div v-if="item.ParentMenuName == '邀请有礼'" class="img-ico">
                <img
                  src="../../../../static/newStatic/img/Invitation/标1.png"
                  width="62px"
                  height="18px"
                />
              </div>
              <div class="noshow">
                <!-- <transition name="menuShow"> -->
                <el-collapse-transition>
                  <ul class="inul" v-if="item.show && item.ChilMenus.length > 0">
                    <li
                      class="isshow"
                      v-for="(item01, k) in item.ChilMenus"
                      :key="k"
                      v-if="item01.IsShow"
                    >
                      <a
                        :class="{ activeBlue: item01.currentIndex }"
                        @click="clickTwo(k, item)"
                        :href="navUrlAll(item01.MenuUrl)"
                        :target="
                          item01.MenuUrl.indexOf('/PickupBespoke') != -1
                            ? '_blank'
                            : '_self'
                        "
                        >{{ item01.ChildMenuName }}</a
                      >
                    </li>
                  </ul>
                </el-collapse-transition>
                <!-- </transition> -->
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCookie } from "../../../ask/cookiejs";
import Vue from "vue";
import bus from "../../../ask/eventBus";
import { post, fetch } from "../../../ask/axios";
import { getAccountInfo } from "@/util/util";

export default {
  data() {
    return {
      parentList: [] /*父级导航*/,

      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },
      lastIndex: 0,
      firstLevelIndex: -1,
      thirdInfo: "",
      pingPongLogo: false,
      leftnavShow: true,
      isChildActive: false,
      ishightText: false,
      //currentIndex:false,
    };
  },

  watch: {
    $route(to, from) {
      this.isHighlight();
    },
    parentList: {
      async handler(val) {
        // 未认证用户不显示我的百运菜单
        //  let customerInfo = await getAccountInfo(this);
        //  if (customerInfo.IsAuthenticated != 2) {
        //   this.parentList = this.parentList.filter(item => item.ParentMenuName != '我的百运');
        //  }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    this.GetThirdInfo();
    let MenuInfos = JSON.parse(sessionStorage.getItem("MenuInfos"));
    if (MenuInfos) {
      this.parentList = MenuInfos;
      //判断高亮是哪一个
      this.isHighlight();
    } else {
      console.log("菜单");
      await this.initfunction();
    }
  },
  mounted() {
    // 私人定制调用接口

    bus.$on("reGetMenuInfo", (res) => {
      sessionStorage.removeItem("MenuInfos"); //清除菜单栏缓存
      this.initfunction();
    });
    bus.$on("openMenuQuery", (res) => {
      this.openMenuQuery(); //打开查到查价
    });
    this.clearChaStrategy();
  },
  computed: {
    navUrl() {
      return this.$nuxtPage;
    },
  },
  methods: {
    // 判断是否清缓存
    clearChaStrategy() {
      // debugger;
      setTimeout(() => {
        //菜单有更新，暂时不获取本地存储里面的，直接取接口里面返回的数据
        const MenuInfos = JSON.parse(sessionStorage.getItem("MenuInfos"));
        //const MenuInfos =[];
        // sessionStorage.getItem('SalesInfos').IsAuthenticated===2
        // const IsAuthID2= sessionStorage.getItem("SalesInfos")
        const IsAuthID = JSON.parse(
          sessionStorage.getItem("SalesInfos")
        ).IsAuthenticated;
        if (IsAuthID === 2) {
          // let isHave = MenuInfos.find((item) => {
          //   return item.ParentMenuName === "个人中心";
          // }).ChilMenus.find((item) => {
          //   return item.ChildMenuName === "实名认证";
          // });
          let isHave = MenuInfos.find((item) => {
            return item.ParentMenuName === "实名认证";
          });
          if (isHave) {
            sessionStorage.removeItem("MenuInfos"); //清除菜单栏缓存
            this.initfunction();
          }
        } else {
          // debugger;
          let parentMenu;
          let isMatch;
          // MenuInfos.forEach((item) => {
          //   if (item.ParentMenuName === "个人中心") {
          //     parentMenu = item;
          //   }
          // });
          MenuInfos.forEach((item) => {
            if (item.ParentMenuName === "实名认证") {
              parentMenu = item;
            }
          });
          // isMatch = parentMenu.ChilMenus.some((item) => {
          //   return item.ChildMenuName === "实名认证";
          // });
          isMatch = parentMenu;
          if (!isMatch) {
            //未认证,检查到菜单栏有实名认证 , 清除菜单栏缓存
            sessionStorage.removeItem("MenuInfos"); //清除菜单栏缓存
            this.initfunction();
          }
        }
      }, 500);
    },
    goHomePage() {
      window.location.href = this.$nuxtPage;
    },
    goMyBaiyun(item) {
      window.location.href = item.MenuUrl;
    },
    gotoAirInquiry(item) {
      window.location.href = item.MenuUrl;
    },
    //判断链接是否有https://；没有https://则在加上this.$apiAll域名；.substring()方法用于字符串截取； .toLowerCase() 方法用于把字符串转换为小写。
    navUrlAll(url) {
      let urlTitle = "";
      //console.log('url  '  + url.substring(0,7).toLowerCase(),url)
      urlTitle =
        url.substring(0, 8).toLowerCase() == "https://" ||
          url.substring(0, 7).toLowerCase() == "http://"
          ? url
          : this.$apiAll + url;
      return urlTitle;
    },
    openMenuQuery() {
      this.firstLevelIndex = 1;
      this.parentList.forEach((item) => {
        if (item.ID === 1) {
          item.show = true;
        } else {
          item.show = false;
        }
      });
    },
    navUrlAll2(url) {
      let urlTitle = "";
      if (url.substring(0, 8).toLowerCase() == "https://") {
        let strUrl = url.substr(8);
        let lastUrlName = strUrl.substring(strUrl.indexOf("/")); //m.MenuUrl 把https://去掉，然后再截取'/'后面的字符串，多级路由也适用
        urlTitle = lastUrlName;
      }
      return urlTitle;
    },

    /*菜单导航接口*/
    async initfunction() {
      let that = this;
      this.api.param = {};
      this.parentList = [];
      // this.api.url = this.$api02 + "/api/EbayCustomer/Menu/Query";
      this.api.url = this.$api04 + "Basics/api/Menu/Query";
      await post(this.api.url, this.api.param).then(function (res) {
        console.log("dasdasdqwe", res);
        if (res.Results) {
          res.Results.forEach((e) => {
            if (e.ParentID == 0) {
              var jsonParentMenu = {
                ID: e.ID,
                show: false,
                IsShow: e.IsShow,
                MenuCode: e.MenuCode,
                ParentMenuName: e.MenuName,
                ChilMenus: [],
                ico: e.Icon,
                MenuUrl: e.MenuUrl,
                ishightText: false,
              };
              that.parentList.push(jsonParentMenu);
              // console.log(that.parentList, "that.parentList");
            }
          });
          //子菜单
          res.Results.forEach((e) => {
            if (e.ParentID != 0 && e.IsPageLink == 0) {
              //把子菜单放到对应的主菜单里  //IsPageLink=0的才显示出来，其他的则不显示
              that.parentList.forEach((e2) => {
                if (e2.ID != e.ParentID) {
                  return;
                }
                var jsonChildMenu = {
                  ChildMenuName: e.MenuName,
                  MenuUrl: e.MenuUrl,
                  currentIndex: false, //当前高亮选项
                  IsShow: e.IsShow,
                };
                e2.ChilMenus.push(jsonChildMenu);
                return false;
              });
            }
          });

          //缓存菜单，接口反应慢
          sessionStorage.setItem("MenuInfos", JSON.stringify(that.parentList));

          //判断高亮是哪一个
          that.isHighlight();
        }
      });
    },
    showhome() {
      return ["home"].some((item) => this.$route.name == item);
    },
    //一级菜单点击菜单背景颜色更改
    clickone(item, index) {
      let ishome = this.showhome();
      //debugger
      item.show = !item.show; //二次点击以上
      if (ishome) {
        this.isChildActive = true;
      }

      this.parentList.forEach((item, index) => {
        item.ChilMenus.forEach((m) => {
          if (m.currentIndex) {
            this.ishightText = true;
          }
        });
      });

      // 判断链接函数
      if (item.MenuCode == 'MenuIndex') {
        this.goMyBaiyun(item)
      }

      if (['我的询盘', '我的询价', '我的报表', '企业成员管理', '实名认证', '邀请有礼'].includes(item.ParentMenuName)) {
        this.gotoAirInquiry(item)
      }

      // for (let i = 0; i < this.parentList.length; i++) {
      //     if (i == index) {
      //       this.ishightText = true;
      //     }
      // }
      // this.isChildActive = false
      // if (
      //   (this.firstLevelIndex != null ||
      //     this.firstLevelIndex != undefined ||
      //     this.firstLevelIndex != "") &&
      //   this.firstLevelIndex != index
      // ) {
      //   for (let i = 0; i < this.parentList.length; i++) {
      //     if (i != index) {
      //       this.parentList[i].show = false;
      //     }
      //   }
      //   item.show = true;

      // } else if (this.firstLevelIndex == index) {
      //   item.show = !item.show; //二次点击以上
      // }
      // this.firstLevelIndex = index;
    },

    //二级菜单点击菜单背景颜色更改
    clickTwo(k, item) {
      this.ishightText = true;
      item.currentIndex = k;
      this.firstLevelIndex = -1;
      // debugger
      // return
      this.isChildActive = false;
    },
    //判断当前页面高亮显示哪一个页面
    isHighlight() {
      var addressUrl = this.$route.path; //获取当前页面的url ?前面的值
      if (addressUrl == "/customerCenter") {
        this.isChildActive = true;
        this.firstLevelIndex = 0;
      }

      // 由于公用页面编辑 判断ChannelOwnerType属性是否存在就知道是否是专线和快递
      if (this.$route.query.ChannelOwnerType == 1) {
        addressUrl = "/exp/expList";
      }
      if (this.$route.query.ChannelOwnerType == 2) {
        addressUrl = "/special/specialList";
      }
      //================== 查价下单=========================//
      if (addressUrl == "/checkList/specialLine") {
        //国际专线
        this.setSiteState("MenuAddOrder", "/checkList/specialLine");
      }
      //百运查价-快递查价
      if (addressUrl == "/checkList/expList") {
        this.setSiteState("MenuAddOrder", "/checkList/expList");
      }
      //百运查价-空运查价
      if (addressUrl == "/checkList/airList") {
        this.setSiteState("MenuAddOrder", "/checkList/airList");
      }
      // 百运查价 - FBA头程查价
      if (["/fba/checkPrice", "/fba/checkPrice/list"].includes(addressUrl)) {
        this.setSiteState("MenuAddOrder", "/fba/checkPrice");
      }

      if (
        addressUrl == "/pickup/pickupCheck" ||
        addressUrl == "/PickupBespoke" ||
        addressUrl == "/PickupOrderSucceed"
      ) {
        // 国内提货
        this.setSiteState("MenuAddOrder", "/pickup/pickupCheck");
      }
      //快递订单批量上传
      if (addressUrl == "/exp/expBatchOrder") {
        this.setSiteState("MenuAddOrder", "/exp/expBatchOrder");
      }
      if (addressUrl == "/PackBatchOrder" || addressUrl == "/TemplateManage") {
        //小包批量上传
        this.setSiteState("MenuAddOrder", "/PackBatchOrder");
      }
      if (addressUrl == "/dhl/recordOrder" || addressUrl == "/dhl/printOrder") {
        //1.DHL录单
        this.setSiteState("MenuAddOrder", "/dhl/recordOrder");
      }

      //----------------------------------------我的订单--------------------------------------------------//
      //小包的链接
      if (
        addressUrl == "/OrderPacketList" ||
        addressUrl == "/OrderPacketDetails"
      ) {
        this.setSiteState("MenuOrderManage", "/OrderPacketList");
      }

      // 集运订单的链接
      if (
        addressUrl == "/gather/orderList" ||
        addressUrl == "/gather/orderDetail"
      ) {
        this.setSiteState("MenuOrderManage", "/gather/orderList");
      }

      //-空运的链接
      if (
        addressUrl == "/air/airOrderList" ||
        addressUrl == "/air/airOrderEdit" ||
        addressUrl == "/air/airDetails" ||
        addressUrl == "/air/airOrderSucceed"
      ) {
        this.setSiteState("MenuOrderManage", "/air/airOrderList");
      }
      // 海运散货
      if (
        addressUrl == "/sea/seaOrderList" ||
        addressUrl == "/sea/seaOrderDetail" ||
        addressUrl == "/sea/seaOrderEdit" ||
        addressUrl == "/sea/seaOrderSuccess"
      ) {
        this.setSiteState("MenuOrderManage", "/sea/seaOrderList");
      }
      // 海运整柜
      if (
        addressUrl == "/seaFull/seaFullList" ||
        addressUrl == "/seaFull/seaFullOrderDetail" ||
        addressUrl == "/seaFull/seaFullOrderEdit" ||
        addressUrl == "/seaFull/seaFullOrderEditNew"
      ) {
        this.setSiteState("MenuOrderManage", "/seaFull/seaFullList");
      }
      //专线列表
      if (addressUrl == "/special/specialList" || addressUrl == "/specialLine/bulkOrder") {
        this.setSiteState("MenuOrderManage", "/special/specialList");
      }

      // 专线小包列表
      if (
        addressUrl == "/specialLinePacket" ||
        addressUrl == "/specialLinePacket/orderList"
      ) {
        this.setSiteState("MenuOrderManage", "/specialLinePacket/orderList");
      }

      //取件的连接
      if (
        addressUrl == "/PickupList" ||
        addressUrl == "/PickupEdit" ||
        addressUrl == "/PickupDetails"
      ) {
        this.setSiteState("MenuOrderManage", "/PickupList");
      }
      //问题件列表
      if (addressUrl == "/problem/list" || addressUrl == "/problem/detail") {
        this.setSiteState("MenuOrderManage", "/problem/list");
      }

      //---------------------------------------------  个人中心-我的发票连接  ---------------------------------------------//
      // 1.我的发票
      if (
        addressUrl == "/myInfo/myInvoice" ||
        addressUrl == "/myInfo/myInvChoose" ||
        addressUrl == "/myInfo/myInvEditStand"
      ) {
        this.setSiteState("MenuMyCentre", "/myInfo/myInvoice");
      }
      //2.外币账户
      if (addressUrl == "/myInfo/curAccount") {
        this.setSiteState("MenuMyCentre", "/myInfo/curAccount");
      }
      //3.地址库
      // if (addressUrl == "/myInfo/myAddress") {
      //   this.setSiteState("MenuMyCentre", "/myInfo/myAddress");
      // }
      if (
        addressUrl == "/myInfo/myAddress" ||
        addressUrl == "/myInfo/cargoInfo" ||
        addressUrl == "/myInfo/myInvoice"
      ) {
        this.setSiteState("MenuMyCentre", "/myInfo/myInvoice");
      }
      //4.产品库信息
      // if (addressUrl == "/myInfo/cargoInfo") {
      //   this.setSiteState("MenuMyCentre", "/myInfo/cargoInfo");
      // }
      //空运委托书
      if (addressUrl == "/myInfo/airDelegate") {
        this.setSiteState("MenuMyCentre", "/myInfo/airDelegate");
      }
      //存储报价
      if (addressUrl == "/myInfo/airQueryPriceStore") {
        this.setSiteState("MenuMyCentre", "/myInfo/airQueryPriceStore");
      }
      //我的建议
      if (addressUrl == "/myInfo/myAdvice") {
        this.setSiteState("MenuMyCentre", "/myInfo/myAdvice");
      }
      if (addressUrl == "/myInfo/notice") {
        this.setSiteState("MenuMyCentre", "/myInfo/notice");
      }
      //基本信息
      // if (
      //   addressUrl == "/myInfo/basicInfo" ||
      //   addressUrl == "/myInfo/workTeamDesc"
      // ) {
      //   this.setSiteState("MenuMyCentre", "/myInfo/basicInfo");
      // }
      // 个人中心 基本信息
      if (
        addressUrl == "/myInfo/personalCenter" ||
        addressUrl == "/myInfo/workTeamDesc"
      ) {
        this.setSiteState("MenuMyCentre", "/myInfo/personalCenter");
      }

      //基本信息-我的报表
      if (addressUrl == "/statement") {
        this.setSiteState("MenuMyCentre", "/statement");
      }
      //基本信息-邀请有礼
      if (addressUrl == "/MyInfo/myInvite") {
        this.setSiteState("MenuMyCentre", "/MyInfo/myInvite");
      }
      //基本信息-实名认证
      if (addressUrl == "/notCertified" || addressUrl == "/successCertified") {
        this.isChildActive = true;
        this.firstLevelIndex = 0;
        this.setSiteState("MenuMyCertification", "/notCertified");
      }

      //------ ---------  快递  ---------------------------------------------//

      //快递订单列表
      //console.log('this.$route.query.type ' + this.$route.query.type);
      if (this.$route.query.type == "Eline") {
        if (addressUrl == "/exp/expDetails") {
          this.setSiteState("MenuOrderManage", "/special/specialList");
        }
      }
      if (this.$route.query.type == "exp") {
        if (addressUrl == "/exp/expDetails") {
          this.setSiteState("MenuOrderManage", "/exp/expList");
        }
      }
      if (this.$route.query.type == "Packet") {
        if (addressUrl == "/exp/expDetails") {
          this.setSiteState("MenuOrderManage", "/specialLinePacket/orderList");
        }
      }

      // FBA 订单
      if (
        [
          "/fba/order/list",
          "/fba/order/detail",
          "/fba/order/orderEdit",
          "/fba/order/OrderSuccess",
        ].includes(addressUrl)
      ) {
        this.setSiteState("MenuOrderManage", "/fba/order/list");
      }

      if (
        addressUrl == "/exp/expList" ||
        addressUrl == "/exp/explist" ||
        addressUrl == "/exp/expOrderSuccess" ||
        addressUrl == "/exp/bulkOrder"
      ) {
        this.setSiteState("MenuOrderManage", "/exp/expList");
      }

      //我的询盘-报价单
      if (
        addressUrl == "/myInquiry/airInquiry" ||
        addressUrl == "/myInquiry/airInDetails" ||
        addressUrl == "/myInquiry/customerInquiry"
      ) {
        this.isChildActive = true;
        this.firstLevelIndex = 2;
        this.setSiteState("MenuPriceOrder", "/myInquiry/airInquiry");
      }
      //------ ---------  个人中心  ---------------------------------------------//
      //我的发票
      // addressUrl == "/myInfo/myInvoice" ||
      if (
        addressUrl == "/myInfo/myInvChoose" ||
        addressUrl == "/myInfo/myInvEditStand" ||
        addressUrl == "/myInfo/myInvEditDHL" ||
        addressUrl == "/myInfo/myInvEditEasy" ||
        addressUrl == "/myInfo/myInvEditOther" ||
        addressUrl == "/myInfo/myInvEditUpsFed" ||
        addressUrl == "/myInvEditIndia/myInvEditEasy"
      ) {
        this.setSiteState("MenuMyCentre", "/myInfo/airDelegate");
        // this.setSiteState("MenuMyCentre", "/myInfo/myInvoice");
      }
      //------ --------- 我的账户-账单查询  ---------------------------------------------//
      if (addressUrl == "/myAccount/billList") {
        this.setSiteState("MenuAccountManage", "/myAccount/billList");
      }
      //------ --------- 我的账户-小包账单  ---------------------------------------------//
      if (addressUrl == "/myAccount/packetBill") {
        this.setSiteState("MenuAccountManage", "/myAccount/packetBill");
      }
      //------ --------- 我的账户-优惠券  ---------------------------------------------//
      if (addressUrl == "/myAccount/accCoupons") {
        this.setSiteState("MenuAccountManage", "/myAccount/accCoupons");
      }
      //------ --------- 我的账户-开票管理  ---------------------------------------------//
      if (addressUrl == "/myAccount/checkInvoice") {
        this.setSiteState("MenuAccountManage", "/myAccount/checkInvoice");
      }
      //------ --------- 我的账户-账户余额 ---------------------------------------------//
      if (
        addressUrl == "/myAccount/accountBalance" ||
        addressUrl == "/myAccount/creditDetail" ||
        addressUrl == "/myAccount/accountCredit"
      ) {
        this.setSiteState("MenuAccountManage", "/myAccount/accountBalance");
      }
      // if (addressUrl == "/myAccount/creditDetail") {
      //   this.setSiteState("MenuAccountManage", "/Account/MyBalance.aspx");
      // }
      // 企业成员管理
      if (addressUrl == "/myInfo/enterprise") {
        this.isChildActive = true;
        this.firstLevelIndex = 5;
        this.setSiteState("MenuEnterpriseMemberManage", "/myInfo/enterprise");
      }
      if (addressUrl == "/MyInfo/myInvite") {
        this.isChildActive = true;
        this.firstLevelIndex = 6;
        this.setSiteState("MenuMyInvite", "/MyInfo/myInvite");
      }
      //--=======推广管理=======
      if (
        addressUrl == "/promotion/visitors"
      ) {
        this.setSiteState("PromotionManage", "/promotion/visitors");
      }
      if (
        addressUrl == "/promotion/customers"
      ) {
        this.setSiteState("PromotionManage", "/promotion/customers");
      }
      if (
        addressUrl == "/promotion/accountBalance"
      ) {
        this.setSiteState("PromotionManage", "/promotion/accountBalance");
      }
    },

    setSiteState(firstName, secondUrl) {
      this.parentList.forEach((item, index) => {
        item.ChilMenus.forEach((m) => {
          m.currentIndex = false;
        });
      });
      this.parentList.forEach((item, index) => {
        if (item.MenuCode == firstName) {
          //this.firstLevelIndex = index;
          item.ChilMenus.forEach((m) => {
            //var lastUrlName=m.MenuUrl.substring(m.MenuUrl.lastIndexOf('/'),m.MenuUrl.length)  //直接获取最后的'/'的字符串，如果后面又多级的路由就不适用
            var strUrl = m.MenuUrl.substr(8);
            var lastUrlName = strUrl.substring(strUrl.indexOf("/")); //m.MenuUrl 把https://去掉，然后再截取'/'后面的字符串，多级路由也适用
            if (lastUrlName == secondUrl) {
              this.ishightText = true;
              item.ishightText = true;
              m.currentIndex = true;
            } else {
              m.currentIndex = false;
            }
          });
          item.show = true;
        } else {
          item.show = false;
        }
      });
    },
    // CustomerInfo() {
    //   this.api.url =
    //     this.$api02 + "/api/EbayCustomer/CustomerInfo/GetCustomerInfoByToken";
    //     this.$api04 + "Basics/api/CustomerInfo/GetCustomerInfoByToken";
    //   this.api.param = {};
    //   return new Promise((resolve, reject) => {
    //     post(this.api.url, this.api.param).then((response) => {
    //       resolve(response);
    //     });
    //   });
    // },

    async GetThirdInfo() {
      //let res = await this.CustomerInfo();
      let loginInfos = JSON.parse(sessionStorage.getItem("loginMessage"));
      this.CustomerThirdInfo(loginInfos.CustomerID);
    },
    CustomerThirdInfo(CustomerID) {
      let that = this;
      // that.api.url = that.$api02 + "/api/EbayCustomer/CustomerThirdInfo/Query";
      that.api.url = that.$api04 + "Basics/api/CustomerThirdInfo/Query";
      that.api.param = {
        CustomerID: CustomerID,
      };
      post(that.api.url, that.api.param).then((res) => {
        if (res.IsOK) {
          this.thirdInfo = res.Results;
          if (this.thirdInfo.length) {
            if (this.thirdInfo[0].ThirdValue == 101) {
              this.pingPongLogo = true;
            } else {
              this.pingPongLogo = false;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.noshow {
  width: 200px;
  box-sizing: border-box;
}
.inul {
  background: #f6f8fa !important;
  padding: 8px;
  box-sizing: border-box;
}
.drowDown {
  position: absolute;
  right: 16px;
  top: 12px;
}
.drowDownTrans {
  width: 16px;
  height: 16px;
  transform: rotate(180deg);
  transition: transform 0.2s;
  background: url("../../../../static/img/左侧导航／浅色／选中／下拉@2x.png");
  background-size: 100% 100%;
}
.closeDrow {
  width: 16px;
  height: 16px;
  transform: rotate(0deg);
  transition: transform 0.2s;
  background: url("../../../../static/img/左侧导航／浅色／未选中／下拉@2x.png");
  background-size: 100% 100%;
}
.ulTransform li:nth-of-type(1) {
  transition: all 58s;
}
.active {
  background: rgba(0, 70, 185, 0.16);
  border-radius: 8px;
  color: #0046b9 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.hightext {
  color: #0046b9 !important;
}
.activeChild {
  border-radius: 8px;
  color: #0046b9 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.activeChild .iconColor {
  color: #0046b9;
}
.active .iconColor {
  color: #0046b9;
}
.activeMyInvite {
  background: rgba(86, 67, 237, 0.08);
  color: #5643ed !important;
}
.activeMyInvite .iconColor {
  color: #5643ed;
}
.iconColor {
  font-size: 16px;
  color: #aaaaaa;
}
.activeBlue {
  background: rgba(0, 70, 185, 0.16);
  opacity: 1;
  line-height: 40px;
  display: block;
  color: #0046b9;
  font-weight: 500;
}
.juzhong li div ul {
  background: rgba(0, 70, 185, 0);
}
a {
  color: #fff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.juzhong li {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  cursor: pointer;
}

.juzhong {
  text-align: center;
}

.ico01 {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.showspan {
  padding: 0 0 0 5px;
  display: inline-block;
}

.navOne {
  width: 184px;
  margin: 8px;
  line-height: 40px;
  padding-left: 20px;
  text-align: left;
  color: #333333;
  /* margin-bottom: 8px; */
  position: relative;

  .bq-img {
    display: inline;
    // margin-top: -7px;
    position: absolute;
    top: -5px;
    left: 73px;
    z-index: 1000;
  }
}
.navOne:hover {
  font-weight: 400;
  background-color: rgba(208, 217, 232, 0.4);
  border-radius: 8px;
}

.isshow {
  line-height: 40px;
  text-align: left;
  color: #333333;
  border-radius: 8px;
  /* margin-bottom: 8px; */
}

.isshow:nth-last-of-type(1) {
  margin-bottom: 0px;
}
.isshow a {
  padding-left: 43px;
  display: block;
  border-radius: 8px;
  width: 100%;
}
.isshow a:hover {
  outline: none;
  background-color: rgba(208, 217, 232, 0.4);
  /* opacity: 0.1; */
}
.isshow a:active {
  color: #0046b9;
}
/* .arrShow:first-child .lnr-chevron-left{display:none} */
.arrShow .lnr-chevron-left {
  margin-left: 10px;
}
.arrTranForm {
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* IE 9 */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg); /* Opera */
}
.nav02 {
  text-align: center;
}
.img-ico {
  position: relative;
  top: -56px;
  left: 94px;
}

.nav01 > span {
  padding: 0 35px 0 5px;
}

.nav01 {
  text-align: center;
  line-height: 40px;
}

/* .leftnav-bot {padding-top: 110px; overflow-x:hidden;overflow-y:auto;height:100%;} */
.leftnav-bot {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  user-select: none;
  padding: 4px 0 56px 0;
  box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.08) !important;
}
/*滚动条样式*/
/* .leftnav-bot::-webkit-scrollbar { width: 5px;  }
    .leftnav-bot::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.6);
        background: rgba(0,0,0,0.2);
    }
    .leftnav-bot::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);

    } */

/* .leftnav-top > a {
    width: 160px;
    height: 50px;
    padding: 15px 15px;
    font-size: 18px;
    line-height: 20px;

  } */

.leftnav-top > a > img {
  width: 120px;
  vertical-align: top;
  margin: 0 auto;
}
.leftnav-top {
  width: 160px;
  height: 64px;
  position: fixed;
  padding-top: 35px;
  z-index: 999;
  top: 0;
}
.leftnav {
  width: 100%;
  height: calc(100vh - 60px);
  background: #ffffff;
}
* {
  box-sizing: border-box;
}

.sidebar {
  z-index: 998;
}
.leftnav .sidebar {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  width: 160px;
  height: 100%;
  float: left;
  background: #193352;
  position: fixed;
  left: 0;
}
.menuShow-enter,
.menuShow-leave-to {
  opacity: 0;
}
.menuShow-enter-to,
.menuShow-leave {
  opacity: 1;
}
.menuShow-enter-active,
.menuShow-leave-active {
  transition: all 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/public/leftNav.vue